import { AppEnum, SolutionType, ToolName } from '../Types/enums';
import { Folder } from '../Types/folder';
import { PromptLabelCounts } from '../Types/tags';

export const CONVERSATION_LIST_SIZE = 12;
export const FOLDER_LIST_SIZE = 15;
export const GLOBAL_RESULTS_LIST_SIZE = 15;
export const PROMPT_PAGE_SIZE = 10;

export const myFolder = {
  id: 'chat',
  name: 'My Folder',
  pinned: false,
} as Folder;

export const INITIAL_TAG_DEFAULTS: PromptLabelCounts = [];

export const PROMPT_DEFAULTS = {
  title: '',
  description: '',
  prompt: '',
  userEditRequired: false,
  published: false,
  metadata: { temperature: 0.5 },
  labels: [] as string[],
  tags: [] as string[],
  tools: [] as ToolName[],
  featured: false,
  appName: AppEnum.NIGEL,
  variables: [] as string[],
  solutionType: SolutionType.PROMPT,
  archived: false,
};

export const RESEARCH_CREDITS = import.meta.env.VITE_DEEP_RESEARCH_CREDITS;
